import React from  "react"
import { useState, useEffect, useRef} from "react"
import { Formik, Form, useField, FormikProps } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import CommonVars from "../Component/CommonVars";
import {
    Flex,
    Heading,
    Input,
    Button,  
    Stack,
    chakra,
    Box,
    Link,
    Avatar,
  } from "@chakra-ui/react";
  import { FaUserAlt, FaLock } from "react-icons/fa";


  const MyTextField = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    return (
      <>
        <label>
          {label}
        </label>

        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };


function RegisterScreen(props){

    const [getDetails, setDetails] = useState('')
    
    useEffect(()=>{
        // var form = document.querySelector("form");;
        // form.addEventListener("submit", function(event){
        // event.preventDefault()
        // });
    }, [])

    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const headers = {
        "Content-Type": "application/json",
    }
    return(
        <Formik
            initialValues={{
                username: '',
                fullname: '',
                email:'',
                password: '',
                address:'',
                role:''
            }}

        validationSchema={Yup.object({
            username: Yup.string()
            .min(2,'Username too short!')
            .required('Required'),
            fullname:Yup.string()
            .required('Full name is required!'),
            email : Yup.string()
            .required('Email is required!'),
            password: Yup.string()
            .min(2, 'Password too short!')
            .required('Password is required!'),
            address : Yup.string()
            .notRequired(),
            role : Yup.string()
            .required()
        })}



        onSubmit = {values =>{
            
            console.log("logging in..")
            const registerbody= values;
            console.log(values)
            console.log(registerbody   )
            axios.post(`${CommonVars.API_URL}/user`, registerbody,{
                headers: headers
            })
            .then((response)=>{
                console.log(response)
                alert("Create Account Successfully")
                window.location.href="/login";
            })
        }

        }
        >
                    {props => (

     <Box
     flexDirection="column"
      width="100wh"
      height="110vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center">

    
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p> 
        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
        <Avatar bg="gray.500" />
        <Heading color="black.400">Welcome</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>

          <Form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
                   <MyTextField name="username" type="username" label="Username" />
                   <MyTextField name="fullname" type="fullname" label="Fullname" />
                   <MyTextField name="email" type="email" label="Email" />
                  <MyTextField name="password" type="password" label="Password"/>
                  <MyTextField name="address" type="address" label="Address"/>
                  <MyTextField name="role" type="role" label="Role"/>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="gray"
                width="full"
              >
                                    {props.isSubmitting ? 'Creating...' : 'Create Account'}
              </Button>
            </Stack>
          </Form>

        </Box>
      </Stack>
      </Box>
                     )}
        </Formik>
    )

}

export default RegisterScreen;